import FacebookPixelProvider from '~/providers/facebook-pixel-provider';

export default function ({ app }) {
  console.log('[Facebook Pixel Plugin] Loading...');

  const initializeProvider = () => {
    if (typeof window !== 'undefined' && window.$analytics) {
      const provider = new FacebookPixelProvider();
      window.$analytics.registerProvider('facebook_pixel', provider);
      console.log('[Facebook Pixel Plugin] Provider registered with Analytics Manager');
    } else {
      setTimeout(initializeProvider, 100);
    }
  };

  initializeProvider();
}